import axios, { AxiosRequestConfig } from "axios";
import { _Base } from "../_Base";
import qs from "qs";

export class PublisherPDF extends _Base {
  ENDPOINTROOT = process.env.REACT_APP_ROOT_T_API;
  async getPdfList(additionalCookies) {
    let url = this.ENDPOINTROOT + "pdfpublisher/get-pdf-list";
    return this.preparePost(
      url,
      {
        additionalCookies: additionalCookies,
      },
      null
    );
  }

  async uploadPDF(data) {
    let url = this.ENDPOINTROOT + "pdfpublisher/upload-pdf";

    const reqParams: AxiosRequestConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      params: {
        ts: new Date().getTime(),
      },
      paramsSerializer: (params: any) => {
        return qs.stringify({ data });
      },
      // data:data,
    };

    // this._setHeaders(reqParams, headers);

    const response = await axios.post(url, data, reqParams);
    return response.data;
  }

  async downloadPDF(data) {
    let url = this.ENDPOINTROOT + "pdfpublisher/download-pdf";
    return fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }
}
